import script from "./TooltipUser.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipUser.vue?vue&type=script&setup=true&lang=js"

import "./TooltipUser.vue?vue&type=style&index=0&id=84f53c26&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84f53c26"]])

export default __exports__